var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0201 10.9133C17.8411 10.9133 19.3171 9.43734 19.3171 7.61634C19.3171 5.79634 17.8411 4.31934 16.0201 4.31934",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5363 14.4971C18.0803 14.5341 18.6203 14.6121 19.1533 14.7301C19.8923 14.8771 20.7823 15.1801 21.0983 15.8431C21.3003 16.2681 21.3003 16.7631 21.0983 17.1881C20.7833 17.8511 19.8923 18.1541 19.1533 18.3061",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59143 15.2061C13.2814 15.2061 16.4334 15.7651 16.4334 17.9981C16.4334 20.2321 13.3014 20.8101 9.59143 20.8101C5.90143 20.8101 2.75043 20.2521 2.75043 18.0181C2.75043 15.7841 5.88143 15.2061 9.59143 15.2061Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5914 12.019C7.1574 12.019 5.2074 10.068 5.2074 7.634C5.2074 5.201 7.1574 3.25 9.5914 3.25C12.0254 3.25 13.9764 5.201 13.9764 7.634C13.9764 10.068 12.0254 12.019 9.5914 12.019Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.35d8f361.svg";
export { ForwardRef as ReactComponent };